import { render } from "./ClientAccountChart.vue?vue&type=template&id=32209a5a&scoped=true"
import script from "./ClientAccountChart.vue?vue&type=script&lang=js"
export * from "./ClientAccountChart.vue?vue&type=script&lang=js"

import "./ClientAccountChart.vue?vue&type=style&index=0&id=32209a5a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-32209a5a"

export default script